module.exports = __webpack_public_path__ + "static/team-illustration-8163da5c1c864e48201de467096c082f.svg";